import React, { useEffect } from "react";
import { LoggerModule } from "@vlinder-web/logger-module-react";

import { useMachine } from "@xstate/react";
import { createMachine } from "xstate";

import { actions } from "./actions";
import { MACHINE_CONFIG } from "./config";
import { services } from "./services";

export const GetPaymentTxnReportContext = React.createContext({});
export let getPaymentTxnReportMachine: any;


const MODULE_NAME = "machines.PaymentReport";
const log: any = LoggerModule?.getInstance();

export const useSMGetPaymentTxnReport = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  getPaymentTxnReportMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(getPaymentTxnReportMachine);

  return {
    getPaymentTxnReportMachine,
    getPaymentTxnReportState: state,
    getPaymentTxnReportSend: send,
  };
};
